import React from "react";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../utils/userManager";
import { jwtDecode } from "jwt-decode";
import Styles from "./callback.module.css";

const CallbackPage = () => {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={(user) => {
        if (user) {
          const decodedToken = jwtDecode(user?.access_token);
          localStorage.setItem("expiry_time", decodedToken?.exp?.toString());
          localStorage.setItem("email", decodedToken?.email);

          localStorage.setItem(
            "location",
            JSON.stringify(decodedToken?.location)
          );
          localStorage.setItem("isLoggedIn", "true");

          const actualToken =
            decodedToken[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ];

          localStorage.setItem("roles", actualToken);
          localStorage.setItem("accessToken", user.access_token);

          window.location.href = "/home";
        } else {
          window.location.href = "/logout";
        }
      }}
      errorCallback={(error) => {
        console.error(error);
      }}
    >
      <div>
        <div className={Styles.loadingContainer}>
          <div className={Styles.loadingSpinner}></div>
          <div className={Styles.loadingText}>Loading...</div>
        </div>
      </div>
    </CallbackComponent>
  );
};

export default CallbackPage;
